export default __webpack_public_path__ + "static/media/javaScript.fd46ca41.svg";